var map = {
	"./poly-1.png": "f15a",
	"./poly-2.png": "bdef",
	"./poly-3.png": "f18c",
	"./poly-4.png": "5720",
	"./poly-5.png": "6b0c",
	"./poly-6.png": "b04d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d0d6";